import { useCallback, useState } from 'react';

export function useToggle(initState = false) {
  const [isTruthy, setIsTruthy] = useState(initState);

  const handleChange = useCallback((newState?: boolean) => {
    setIsTruthy((prevState) => (typeof newState === 'boolean' ? newState : !prevState));
  }, []);

  return [isTruthy, handleChange] as const;
}
